export class InspectionAttachment {
  constructor(
    public readonly id: string,
    public readonly inspectionId: string,
    public readonly name: string,
    public readonly order: number,
  ) {}

  static fromJson(json: any): InspectionAttachment {
    return new InspectionAttachment(json["id"], json["inspection_id"], json["name"], json["order"]);
  }
}
